import styled from 'styled-components/macro'
import { ReactComponent as TickIconBase } from '../../../../../components/Icons/tick-icon.svg'
import { em } from '../../../../../utils/styles'

const TickIcon = styled(TickIconBase)`
  height: ${em(20)};
`

export default TickIcon
